// extracted by mini-css-extract-plugin
module.exports = {"vacancy":"Vacancy_vacancy__3hHBT"};